import { handleGetFeedback } from 'Actions/SuperAdmin/JobsAction';
import React from 'react'
import { FaArrowLeftLong } from 'react-icons/fa6';
import { useCommonState, useCustomNavigate, useDispatch } from 'ReusableFunctions/CustomHooks';
import { decryptData } from 'Security/Crypto/Crypto';
import { update_feedback_change } from 'Slices/SuperAdmin/Jobs';
import Rating from 'views/common/Rating';

const FeedbackDetailedView = () => {
    const queryparams = new URLSearchParams(window.location.search);
    const { saJobsState } = useCommonState();
    const navigate = useCustomNavigate();
    const dispatch = useDispatch();
    const category = ["Summary", "Feedback"];


    React.useEffect(() => {
        let email_id = queryparams.get("e_id") ? decryptData(queryparams.get("e_id")) : ""

        if (email_id) dispatch(handleGetFeedback({
            endpoint: "/get_user_summary",
            data: { email_id: email_id }
        }))
    }, [])

    return (
        <div className="py-5 h-100 row">
            <div className="col-12  col-md-6 col-lg-8 py-2 py-md-0">
                <button
                    className="btn btn-transparent d-flex align-items-center gap-2"
                    onClick={() => {
                        navigate(`/super_admin/feedback`);
                    }}
                >
                    <FaArrowLeftLong className="fs-5" /> Chat Summary of {queryparams.get("role")?.charAt(0)?.toUpperCase() + queryparams.get("role")?.slice(1) || 'User'}
                </button>
            </div>
            <div className="col-12 col-md-6 col-lg-4 row pb-3 ms-auto">
                <select className="form-select" value={saJobsState?.feedback_summary_category} onChange={(e) => dispatch(update_feedback_change({ type: "feedback_summary_category", data: e.target.value }))}>
                    {category.map((item, index) => (
                        <option key={index} value={item?.toLowerCase()}>{item}</option>
                    ))}
                </select>
            </div>

            {
                saJobsState?.feedback_glow ?
                    <div className="d-flex flex-wrap justify-content-center align-items-center" style={{ height: '100%' }}>
                        <div className="col-4 text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className='w-100 mt-2'>Getting feedback..</p>
                        </div>
                    </div>
                    :
                    saJobsState?.feedback_data?.length ?
                        saJobsState?.feedback_data
                            ?.filter((item) => item?.transcript_summary)?.length ?
                            <>
                                <div className="card px-3 mb-3 py-3 rounded-3">
                                    <div className="card-body px-0 row g-2 align-items-center">
                                        <div className="col-12 col-md-6 col-xxl-4 pb-3 pb-lg-0">
                                            <h6 className='mb-0'>
                                                <strong>
                                                    {queryparams.get("role")?.charAt(0)?.toUpperCase() + queryparams.get("role")?.slice(1)} Id :
                                                </strong>
                                                <span className='ps-2'>
                                                    {saJobsState?.feedback_data[0]?.user_id || ''}
                                                </span>
                                            </h6>
                                        </div>
                                        <div className="col-12 col-md-6 col-xxl-4 pb-3 pb-lg-0">
                                            <h6 className='mb-0'>
                                                <strong>
                                                    Name :
                                                </strong>
                                                <span className='ps-2'>
                                                    {saJobsState?.feedback_data[0]?.full_name || ''}
                                                </span>
                                            </h6>
                                        </div>
                                        <div className="col-12 col-md-6 col-xxl-4 pb-3 pb-lg-0">
                                            <h6 className='mb-0'>
                                                <strong>
                                                    Email :
                                                </strong>
                                                <span className='ps-2'>
                                                    {saJobsState?.feedback_data[0]?.email_id || ''}
                                                </span>
                                            </h6>
                                        </div>
                                    </div>
                                </div>

                                <div className="card px-3 rounded-3" style={{ height: '80%', overflowY: 'scroll', paddingBottom: "10rem" }}>
                                    <div className="card-body px-0">
                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead>
                                                    <tr className='d-flex'>
                                                        <th className='col'>S.No</th>
                                                        {/All|Summary/i.test(saJobsState?.feedback_summary_category) ? <th className='col'>Chat Summary</th> : null}
                                                        {/All|Feedback/i.test(saJobsState?.feedback_summary_category) ? <th className='col'>Feedback</th > : null}
                                                        <th className='col'>Timestamp</th>
                                                        {/All|Feedback/i.test(saJobsState?.feedback_summary_category) ? <th className='col'>Ratings</th> : null}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        saJobsState?.feedback_data
                                                            ?.filter((item) => item?.transcript_summary)
                                                            ?.map((feedback, feedback_index) => (
                                                                <tr className='d-flex'>
                                                                    <td className='col'>{feedback_index + 1}</td>
                                                                    {/All|Summary/i.test(saJobsState?.feedback_summary_category) ? <td className='col'>{feedback?.transcript_summary || "None"}</td> : null}
                                                                    {/All|Feedback/i.test(saJobsState?.feedback_summary_category) ? <td className='col'>{feedback?.feedback || "** Feedback Not Provided **"}</td > : null}
                                                                    <td className='col'>{feedback?.created_at}</td>
                                                                    {/All|Feedback/i.test(saJobsState?.feedback_summary_category) ?
                                                                        <td className='col'>
                                                                            <span className='ps-2 d-inline-block'>
                                                                                <Rating rated={feedback?.rating || 0} className="pe-none" />
                                                                            </span>
                                                                        </td>
                                                                        :
                                                                        null
                                                                    }
                                                                </tr>
                                                            ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            <div className="d-flex flex-wrap justify-content-center align-items-center" style={{ height: '100%' }}>
                                <p className='text-center'>No Data Found</p>
                            </div>
                        :
                        <div className="d-flex flex-wrap justify-content-center align-items-center" style={{ height: '100%' }}>
                            <p className='text-center'>No Data Found</p>
                        </div>
            }
        </div >
    )
}

export default FeedbackDetailedView